import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { register } from "../../actions/auth";
import PropTypes from "prop-types";
import { toastr } from "react-redux-toastr";

const Register = ({
  isShowingRegister,
  hideRegister,
  openLogin,
  switched,
  register,
  isAuthenticated,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    password2: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const { name, email, password, password2 } = formData;
  const passwordsMismatch = password2 !== "" && password !== password2;
  const onChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  // Keep the name and email between openings, but never leave passwords behind.
  const reset = () => {
    setShowPassword(false);
    setFormData((data) => ({ ...data, password: "", password2: "" }));
  };

  const close = () => {
    reset();
    hideRegister();
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting) {
      return;
    }
    if (password !== password2) {
      toastr.error("Нууц үгүүд хоорондоо таарсангүй");
      return;
    }
    setIsSubmitting(true);
    if (!(await register({ name, email, password }))) {
      // On success the navbar swaps to signed-in links and unmounts this modal.
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (!isShowingRegister) {
      return undefined;
    }
    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        close();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  });

  if (isAuthenticated) {
    return <Redirect to="/upload" />;
  }
  if (!isShowingRegister) {
    return null;
  }

  return (
    <div
      id="auth-modal"
      className={`modal is-active dialog-modal ${switched ? "is-switched" : ""}`}
    >
      <div className="modal-background" onClick={close}></div>
      <div className="modal-content">
        <div
          className="dialog-box"
          role="dialog"
          aria-modal="true"
          aria-labelledby="register-title"
        >
          <button
            type="button"
            className="dialog-close"
            aria-label="Хаах"
            onClick={close}
          >
            <i className="fas fa-times" aria-hidden="true"></i>
          </button>

          <span className="dialog-icon" aria-hidden="true">
            <i className="fas fa-user-plus"></i>
          </span>
          <h2 id="register-title">Бүртгүүлэх</h2>
          <p className="dialog-lead">
            Бүртгэл үүсгээд файлаа хэдхэн алхмаар хэвлээрэй.
          </p>

          <form onSubmit={onSubmit}>
            <div className="field">
              <label className="dialog-label" htmlFor="register-name">
                Нэр
              </label>
              <div className="control has-icons-left">
                <input
                  id="register-name"
                  type="text"
                  className="input"
                  name="name"
                  value={name}
                  placeholder="Таны нэр"
                  autoComplete="name"
                  autoFocus
                  required
                  onChange={onChange}
                />
                <span className="icon is-left">
                  <i className="fas fa-user" aria-hidden="true"></i>
                </span>
              </div>
            </div>

            <div className="field">
              <label className="dialog-label" htmlFor="register-email">
                Имэйл
              </label>
              <div className="control has-icons-left">
                <input
                  id="register-email"
                  type="email"
                  className="input"
                  name="email"
                  value={email}
                  placeholder="name@example.com"
                  autoComplete="email"
                  required
                  onChange={onChange}
                />
                <span className="icon is-left">
                  <i className="fas fa-envelope" aria-hidden="true"></i>
                </span>
              </div>
            </div>

            <div className="field">
              <label className="dialog-label" htmlFor="register-password">
                Нууц үг
              </label>
              <div className="control has-icons-left">
                <input
                  id="register-password"
                  type={showPassword ? "text" : "password"}
                  className="input dialog-password-input"
                  name="password"
                  value={password}
                  placeholder="Хамгийн багадаа 6 тэмдэгт"
                  autoComplete="new-password"
                  minLength={6}
                  required
                  onChange={onChange}
                />
                <span className="icon is-left">
                  <i className="fas fa-lock" aria-hidden="true"></i>
                </span>
                <button
                  type="button"
                  className="dialog-password-toggle"
                  aria-label={
                    showPassword ? "Нууц үгийг нуух" : "Нууц үгийг харуулах"
                  }
                  aria-pressed={showPassword}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <i
                    className={`fas ${showPassword ? "fa-eye-slash" : "fa-eye"}`}
                    aria-hidden="true"
                  ></i>
                </button>
              </div>
            </div>

            <div className="field">
              <label className="dialog-label" htmlFor="register-password2">
                Нууц үгээ давтах
              </label>
              <div className="control has-icons-left">
                <input
                  id="register-password2"
                  type={showPassword ? "text" : "password"}
                  className={`input ${passwordsMismatch ? "is-danger" : ""}`}
                  name="password2"
                  value={password2}
                  placeholder="Нууц үгээ дахин оруулна уу"
                  autoComplete="new-password"
                  aria-invalid={passwordsMismatch}
                  aria-describedby={
                    passwordsMismatch ? "register-password2-help" : undefined
                  }
                  required
                  onChange={onChange}
                />
                <span className="icon is-left">
                  <i className="fas fa-lock" aria-hidden="true"></i>
                </span>
              </div>
              {passwordsMismatch && (
                <p id="register-password2-help" className="dialog-help">
                  Нууц үгүүд хоорондоо таарахгүй байна.
                </p>
              )}
            </div>

            <button
              type="submit"
              className={`button is-fullwidth dialog-submit ${
                isSubmitting ? "is-loading" : ""
              }`}
              disabled={isSubmitting}
            >
              Бүртгүүлэх
            </button>
          </form>

          <p className="dialog-footer">
            Бүртгэлтэй юу?{" "}
            <button
              type="button"
              className="dialog-link"
              onClick={() => {
                reset();
                openLogin();
              }}
            >
              Нэвтрэх
            </button>
          </p>
        </div>
      </div>
    </div>
  );
};

// The modal props are optional because the /register route also renders this bare.
Register.propTypes = {
  isShowingRegister: PropTypes.bool,
  hideRegister: PropTypes.func,
  openLogin: PropTypes.func,
  // Opened by the other auth dialog handing over, so it skips the opening animation
  switched: PropTypes.bool,
  register: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});
export default connect(mapStateToProps, { register })(Register);
